// client/src/constants/adminConstants.js

export const USER_TYPES = {
  MEMBER: { value: "2", code: "member", label: "Member" },
  MEMBER_ADMIN: { value: "3", code: "member_admin", label: "Member Admin" },
  ADMIN: { value: "4", code: "admin", label: "Admin" },
  RESEARCH_COORDINATOR: {
    value: "5",
    code: "research_coordinator",
    label: "Research Coordinator",
  },
};

export const STAT_TYPES = {
  USERS: { value: "1", label: "Users" },
  REGISTRATIONS_CURRENT: {
    value: "2",
    label: "Registrations - Current Meeting",
  },
  ATTENDANCE: { value: "3", label: "Attendance" },
  USER_EMAIL_LIST: { value: "4", label: "User Email List" },
  RESEARCH_COORDINATOR_EMAIL_LIST: {
    value: "5",
    label: "Research Coordinator Email List",
  },
  DATA_REQUESTS: { value: "6", label: "Data Requests" },
  VOTES: { value: "7", label: "Votes" },
};

export const EMAIL_VALIDATION_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const ALERT_OVERRIDES = { display: "block", marginTop: "-100px" };

export const REACT_APP_SERVER_URL =
  process.env.REACT_APP_SERVER_URL || "http://localhost:3000";

